import { createStyles } from "@mantine/emotion";

export default createStyles ( () => {
	return {
		baseStyles: {
			background : "none",
			border     : "none",
			cursor     : "pointer"
		}
	};
} );
